const sortByPlanType = (predicate, plans, a, b) => predicate(plans[a].type, plans[b].type)

export default sortByPlanType
